                                    package space.stanton.generated
                                    
                                    public object BlogIndex {
  public val posts: kotlin.collections.List<space.stanton.generated.BlogPostInfo> = listOf(BlogPostInfo(
                           title = "Hello world",
                           date = "2024_06_14",
                           route = "/posts/bp-2024-06-14-hello",
                           excerpt = "posts/bp_2024_06_14_hello.md",
                           tags = emptyList()),
      BlogPostInfo(
                           title = "Where it all began",
                           date = "2025_05_17",
                           route = "/posts/bp-2025-05-17-where-it-all-began",
                           excerpt = "posts/bp_2025_05_17_where_it_all_began.md",
                           tags = emptyList()),
      BlogPostInfo(
                           title = "A few useful bash commands",
                           date = "2025_08_25",
                           route = "/posts/bp-2025-08-25-a-few-useful-bash-commands",
                           excerpt = "posts/bp_2025_08_25_a_few_useful_bash_commands.md",
                           tags = emptyList()))
}
